export const AustrianGermanLabel = {
    Enter_the_following_information_to_enter: 'Geben Sie die folgenden Informationen ein, um einzutreten',
    login: 'Login',
    Username: 'Benutzername',
    password: 'Passwort',
    Orders: 'Bestellungen',
    Online: 'Online',
    Offline: 'Offline',
    Info: 'Info',
    email: 'E-Mail',
    vehicletypes: 'Servicetypen',
    loginstatus: 'Anmeldestatus',
    lastonlinetime: 'letzte Online-Zeit',
    fetchingdata: 'Informationen werden empfangen...',
    poperLoading: 'Bitte warten',
    Noinformationfound: 'Keine Informationen gefunden',
    Drivers: 'Fahrer',
    otherdropoffs: 'andere Abgaben',
    paymentmethod: 'Zahlungsart',
    Receiver: 'Vom Empfänger',
    Sender: 'Vom Absender',
    Balance: 'Gleichgewicht',
    Cash: 'Kasse',
    Wallet: 'Geldbörse',
    Close: 'Schließen',
    noVehicleType: 'Es gibt keinen anzuzeigenden Diensttyp',
    Fname: 'Vorname',
    Lname: 'Nachname',
    Pnumber: 'Telefonnummer',
    driver: 'Fahrer',
    DropOff: 'Abgeben',
    Noaddressavailable: 'Keine Adresse verfügbar',
    Managefavoriteaddresses: 'Adressen verwalten',
    address: 'Adresse',
    Saved: 'Gespeichert',
    block: 'Block',
    Floor: 'Boden',
    Unit: 'Einheit',
    Recieverfullname: 'Empfängername',
    Recieverphonenumber: 'Empfängernummer',
    notesfordriver: 'Hinweise für den Fahrer',
    Price: 'Preis',
    EditOrder: 'Bestellung bearbeiten',
    Firstname: 'Vorname',
    Lastname: 'Nachname',
    Phonenumber: 'Telefonnummer',
    senderfullname: 'Absendername',
    senderphonenumber: 'Absendernummer',
    Search: 'Suchen',
    Service: 'Service',
    Passenger: 'Kunde',
    Pickup: 'Abholen',
    Pricedetails: 'Preisdetails',
    Fee: 'Gebühr',
    Fornow: 'Zur Zeit',
    Scheduled: 'Geplant',
    before: 'vorher:',
    Settime: 'Uhrzeit einstellen',
    after: 'nach :',
    confirm: 'Bestätigen',
    Cancel: 'Stornieren',
    Addresses: 'Adressen',
    Savedaddresses: 'Gespeicherte Adressen',
    new: 'Neu',
    Editaddress: 'Adresse bearbeiten',
    Saveaddress: 'Adresse speichern',
    Language: 'Sprache',
    en: 'Englisch',
    fa: 'persisch',
    English: 'Englisch',
    Persian: 'persisch',
    Logout: 'Abmelden',
    logotTitle: 'Vom Konto abmelden?',
    logoutDescription: 'Sie werden vom Konto abgemeldet und sollten sich später anmelden',
    confirmLogout: 'Ja, melden Sie sich ab',
    skipLogout: 'Stornieren',
    Ascending: 'Aufsteigend',
    Descending: 'Absteigend',
    'sort[createdAt]': 'Datum',
    'sort[pickupScheduleDate]': 'Abholzeit ',
    'sort[statusUpdatedAt]': 'Sortieren nach Update unter',
    SelectDateRange: 'Datumsbereich',
    StartDate: 'Startdatum',
    EndDate: 'Enddatum',
    Today: 'Heute',
    Yesterday: 'Gestern',
    ThisWeek: 'Diese Woche',
    LastWeek: 'Letzte Woche',
    Last7Days: 'Letzte 7 Tage',
    ThisMonth: 'Diesen Monat',
    LastMonth: 'Letzten Monat',
    monitoring: 'Überwachung',
    Haveorder: 'Habe Bestellung',
    Estimated: 'Geschätzt',
    ReceiverCash: 'Bargeld (durch den Empfänger)',
    SenderCash: 'Kasse ',
    SenderWallet: 'Geldbörse',
    Auto: 'Auto',
    Manual: 'Handbuch',
    SendOrderr: 'Bestellung absenden',
    Neworder: 'Neue Ordnung',
    Person: 'Person',
    Business: 'Geschäft',
    Businessname: 'Firmenname',
    phonenumber: 'Telefonnummer',
    Adddropoff: 'Abgabe hinzufügen',
    Searchbynameorphonenumber: 'Suchen Sie nach Name oder Telefonnummer',
    Fullname: 'Vollständiger Name',
    type: 'Typ',
    only: 'Nur xxx',
    ChooseDriver: 'Fahrer wählen',
    AllKey: 'Alle',
    MeKey: 'Mich',
    Vehicletype: 'Fahrzeugtyp',
    status: 'Zustand',
    statusInProgress: 'Im Gange',
    statusCanceled: 'Abgesagt',
    statusPending: 'Ausstehend',
    statusUnassigned: 'Nicht zugewiesen',
    statusDone: 'Erledigt',
    dispatcher: 'Operator',
    customer: 'Mobile',
    regexcode: 'Code',
    regexcustomerPhone: 'Kunde storniert',
    regexcustomerName: 'Kundenname',
    regexdriverPhone: 'Fahrertelefon',
    regexdriverName: 'Fahrername',
    regexdriverUsername: 'Benutzername des Fahrers',
    pickupDescription: 'Beschreibung der Abholung',
    filter: 'Filter',
    clear: 'Klar',
    orderInfoError: 'Fehler beim Empfangen der Informationen',
    Details: 'Einzelheiten',
    History: 'Geschichte',
    Phone: 'Telefon',
    km: 'km',
    Espath: 'Es. Weg',
    Receipt: 'Quittung',
    Copylink: 'Link kopieren',
    repeatOrder: 'Nachbestellung',
    Edit: 'Bearbeiten',
    EditPrice: 'Preis bearbeiten',
    Endtrip: 'Bestellung beenden',
    Canceltravel: 'Bestellung stornieren',
    CancellText: 'Nach der Stornierung wird die Bestellung für den Fahrer storniert',
    confirmCancel: 'Ja',
    Endtravel: 'vollständig',
    EndlText: 'Mit Abschluss ist die Bestellung für den Kunden und Fahrer erfolgreich abgeschlossen und der Betrag wird vom Kundenkonto abgebucht',
    confirmEnd: 'Ja',
    End: 'Bestellung stornieren',
    Deliveredat: 'Geliefert um ',
    pod: 'Zustellnachweis',
    Notes: 'Notizen',
    Nonotes: 'Keine Notizen',
    Photo: 'Foto',
    Signature: 'Unterschrift',
    Nosignature: 'Keine Unterschrift',
    Nophoto: 'Kein Foto',
    ServiceOptions: 'Serviceoptionen',
    Events: 'Veranstaltungen',
    status2: 'Status',
    Creator: 'Schöpfer',
    Creationdate: 'Erstellungsdatum',
    Orderid: 'Bestellnummer',
    Pickup2: 'Abholen',
    Dropoff2: 'Abgabe',
    PleaseSelect: 'Bitte auswählen',
    CreateEvent: 'Ereignis erstellen',
    Description: 'Beschreibung',
    detailsAboutEvent: 'Details zur Veranstaltung',
    CustomerVisibility: 'Kundensichtbarkeit',
    LocationOnMap: 'Standort auf der Karte',
    Pending: 'Ausstehend',
    Unassigned: 'Nicht zugewiesen',
    Assigned: 'Im Gange',
    PickedUp: 'Im Gange',
    Started: 'Im Gange',
    Done: 'Erledigt',
    CustomerCanceled: 'Abgesagt',
    DriverCanceled: 'Abgesagt',
    SupportCanceled: 'Abgesagt',
    Arrived: 'Im Gange',
    Createdsuccessfully: 'Erfolgreich erstellt',
    Estime: 'Es. Zeit',
    Promocode: 'Aktionscode',
    Updatedsuccessfully: 'Erfolgreich aktualisiert',
    statusAssigned: 'Zugewiesen',
    statusStarted: 'Begonnen',
    statusPickedUp: 'Begonnen',
    statusDriverCanceled: 'Fahrer abgesagt',
    statusArrived: 'Angekommen',
    statusSupportCanceled: 'Support abgebrochen',
    Title: 'Titel',
    ContactFullname: 'Kontakt Vollständiger Name',
    Contactphonenumber: 'Kontakttelefonnummer',
    Commission: 'Kommission',
    surcharge: 'Zuschlag',
    haslogined: 'hat sich eingeloggt',
    Notloggedin: 'Nicht angemeldet',
    Schedule: 'Zeitplan',
    Date: 'Datum',
    Time: 'Zeit',
    noDateToShow: 'Es gibt kein anzuzeigendes Datum',
    noTimeToShow: 'Es gibt keine Zeit zum Anzeigen',
    Apply: 'Anwenden',
    lowBalance: 'niedriges Gleichgewicht',
    balanceError: 'Ihr Guthaben muss mindestens dem Bestellpreis entsprechen',
    Methods: 'Methoden',
    Addressbook: 'Adressbuch',
    AddressbookSearchbar: 'Suche nach Adresse, Titel und ID',
    AddressbookDropOf: 'Adressbuch (Abgabe)',
    AddressbookPickup: 'Adressbuch (Abholung)',
    hide: 'Verstecken',
    Nosavedaddress: 'Keine gespeicherte Adresse',
    Romanian: 'rumänisch',
    business: 'Geschäft',
    username: 'Benutzername',
    rememberme: 'erinnere dich an mich',
    SendOrder: 'Bestellung absenden',
    code: 'Code',
    noorder: 'noOrder',
    pleaseSellectParsel: 'Bitte wählen Sie Service aus',
    Order: 'Befehl',
    Code: 'Code',
    Editorder: 'Bestellung bearbeiten',
    all: 'Alle',
    Address: 'Adresse',
    'Block/Building': 'Block/Gebäude',
    Pickedupat: 'Abgeholt um ',
    for: 'Für',
    fr: 'Französisch',
    AllVehicletypes: 'Alle Servicetypen',
    AllServices: 'Alle Dienstleistungen',
    French: 'Französisch',
    enterDataCorrectly: 'Geben Sie die Informationen korrekt ein.',
    controlThatbeforeLoweEqualAfter: 'Die Zeit „Vorher:“ darf nicht kürzer sein als die Zeit „Nachher:“ ',
    ForceAssign: 'Zuweisung erzwingen',
    Allvehicletypes: 'Alle Fahrzeugtypen',
    waitforconfirm: 'xxx (Auf Bestätigung warten)',
    waitforconfirm2: '(Auf Bestätigung warten)',
    Dispatching: 'Versand',
    NoDriver: 'Kein Fahrer',
    OtherDetails: 'Weitere Details',
    StatusandDriver: 'Status und Treiber',
    EditStatusandDriver: 'Status und Treiber bearbeiten',
    Current: 'Aktuell',
    EDAS_Pending: 'Ausstehend',
    EDAS_Assigned: 'Zugewiesen',
    EDAS_PickedUp: 'Abgeholt',
    EDAS_Unassigned: 'Nicht zugewiesen',
    EDAS_Started: 'Begonnen',
    EDAS_Done: 'Erledigt',
    EDAS_CustomerCanceled: 'Kunde storniert',
    EDAS_DriverCanceled: 'Fahrer abgesagt',
    EDAS_SupportCanceled: 'Support abgebrochen',
    EDAS_Arrived: 'Angekommen',
    Pleasechooseadrivertochangestatus: 'Eine Änderung der Optionen kann sich auf den Preis auswirken',
    icWarningEdit: 'Der Fahrzeugtyp wird geändert',
    Vehicletypewillbechanged: 'Ihr aktueller Fahrzeugtyp ändert sich und dies wirkt sich auf den Preis aus',
    Rejected: 'Abgelehnt',
    Rejected2: '(Abgelehnt)',
    DriverVehicleTypeError: 'Es gibt keinen Fahrzeugtyp für Fahrer',
    CodeNameFamilyPhonenumber: 'Code, Name, Familie, Telefonnummer',
    youcanselectdriverintheedit: 'Sie können den Treiber unter „Treiber und Status bearbeiten“ auswählen',
    Earning: 'Verdienen',
    savePrice: 'Preis sparen',
    saveEarning: 'Sparen Sie Geld',
    Total: 'Gesamt',
    EditPickupDropOff: 'Adressen',
    noMoreData: 'Es gibt keine weiteren Informationen',
    OnDemand: 'Auf Anfrage',
    PD: 'P & D',
    PD2: 'P&D',
    PickupDropoff: 'Abholung, Rückgabe',
    PickupFlag: 'P',
    DropOffFlag: 'D',
    PickupandDelivery: 'Abholung und Lieferung',
    PickupDelivery: 'Abholung und Lieferung',
    Delivery: 'Lieferung',
    Collecting: 'Sammeln',
    Transit: 'Transit',
    Delivering: 'Liefern',
    EDAS_Collecting: 'Sammeln',
    EDAS_Transit: 'Transit',
    EDAS_Delivering: 'Liefern',
    statusCollecting: 'Sammeln',
    statusTransit: 'Transit',
    statusDelivering: 'Liefern',
    serviceCustomerError1: 'xxx ist für diesen Kunden nicht verfügbar.',
    serviceCustomerError2: 'Er/Sie kann nur xxx Service wählen',
    serviceCustomerError3: 'Er/Sie kann nur xxx wählen ',
    OrderCode: 'Bestellcode',
    event_Created: 'Erstellt',
    event_Unassigned: 'Nicht zugewiesen',
    event_Assigned: 'Zugewiesen',
    event_Started: 'Begonnen',
    event_Arrived: 'Angekommen',
    event_PickedUp: 'Abgeholt',
    event_OrderDone: 'Bestellung erledigt',
    event_DropoffDone: 'Abgabe erledigt',
    event_CustomerFeedback: 'Kundenfeedback',
    event_AddPod: 'Pod hinzufügen',
    event_CustomerCanceled: 'Kunde storniert',
    event_DriverCanceled: 'Fahrer abgesagt',
    event_SupportCanceled: 'Support abgebrochen',
    event_Updated: 'Aktualisiert',
    event_DriverAssignment: 'Fahrerzuweisung',
    event_DriverReject: 'Fahrerablehnung',
    event_Collecting: 'Sammeln',
    event_InTransit: 'Unterwegs',
    event_Delivering: 'Liefern',
    event: 'Ereignis',
    tab_Delivery: 'Lieferung',
    tab_Ondemand: 'Auf Anfrage',
    tab_Pickup: 'Abholen',
    tab_PickupDelivery: 'P&D',
    CurrentStatus: 'Aktueller Status',
    Changestatus: 'Status ändern',
    Newstatus: 'Neuer Status',
    Savechanges: 'Änderungen speichern',
    Other: 'Andere',
    Shipmentlabel: 'Versandetikett',
    pleaseSellectService: 'Bitte wählen Sie den Servicetyp aus',
    EditPrice2: 'Preis',
    EditEarning: 'Verdienen',
    statusCustomerCanceled: 'Kunde storniert',
    Yourcurrentvehicletypeanditwillbechangedandeffectsonprice: 'Ihr aktueller Fahrzeugtyp ändert sich und dies wirkt sich auf den Preis aus',
    Dutch: 'niederländisch',
    Ondemand: 'Auf Anfrage',
    todayat: 'Heute um',
    tomorrowat: 'Morgen um',
    nextWeekat: 'Nächste Woche um',
    lastDayat: 'Am nächsten Tag um',
    lastWeekat: 'Letzte Woche um',
    CopyOrderlink: 'Link zur Bestellung kopieren',
    CopyPickuplink: 'Abhollink kopieren',
    CopyDeliverylink: 'Lieferlink kopieren',
    Bulkimport: 'Massenimport',
    Downloadsamplecsv: 'Laden Sie eine Beispiel-CSV-Datei herunter',
    processing: 'Verarbeitung',
    done: 'Fertig',
    failed: 'Fehlgeschlagen',
    Draft: 'Entwurf',
    Uploading: 'Hochladen',
    Draganddropyourfile: 'Ziehen Sie Ihre Datei per Drag & Drop',
    Onlycsvformatissupported: 'Es wird nur das CSV-Format unterstützt',
    ORyoucan: 'ODER du kannst',
    Openfile: 'Datei öffnen',
    Noimportsyet: 'Noch keine Importe',
    NoimportsyetDesc: 'Hier können Sie die Liste Ihrer Importe einsehen und deren Status überprüfen',
    nosupportdialogeTitle: 'Dateiformat wird nicht unterstützt',
    nosupportdialogeText: 'xxx-Datei wird nicht unterstützt. Sie können nur eine CSV-Datei mit Bestellinformationen hochladen',
    ok: 'OK',
    Import: 'Import',
    previewTitle: 'Vorschau und wählen Sie Optionen',
    previewDesc: 'Dies ist das erste Element Ihrer Dateien, bei dem überprüft wird, ob Ihre Informationen die richtige Struktur haben',
    Upload: 'Hochladen',
    Remove: 'Entfernen',
    ServiceandOrdertype: 'Service- und Auftragstyp',
    Fileisproccessing: 'Datei wird verarbeitet ...',
    proccessingDesc: 'Sie können eine Aktualisierung durchführen, um zu sehen, ob das Ergebnis fertig ist',
    serverError: 'Serverfehler',
    isRequired: 'xxx ist erforderlich',
    Result: 'Ergebnis',
    ResultText: 'Sie können die Probleme hier sehen und diese Zeilen herunterladen, um sie separat zu beheben',
    ErrorDetails: 'Bestellungen mit Fehler',
    ErrorDetailsText: 'Bestellungen mit Fehlern sind in der Datei aufgeführt, die Sie unten herunterladen können. Es enthält Fehlerdetails für jede Zeile.',
    DownloadErroredRows: 'Laden Sie fehlerhafte Zeilen herunter',
    importedsuccessfully: 'xxx Bestellungen wurden erfolgreich importiert',
    ordershaserrors: 'xxx Bestellungen sind fehlerhaft',
    refresh: 'Aktualisieren',
    CashOnDelivery: 'Nachnahme',
    EnterAmount: 'Geben Sie den Betrag ein',
    COD: 'Nachnahme',
    Surchargexxx: 'Aufpreis xxx',
    AddCreditCard: 'Kredit-/Debitkarte hinzufügen',
    CustomerWallet: 'Kundengeldbörse',
    Add: 'Hinzufügen',
    Addedsuccessfully: 'Erfolgreich hinzugefügt',
    NoRecentAddress: 'Keine aktuelle Adresse',
    NoRecentAddressD: 'Die aktuellen Kundenadressen werden hier aufgelistet',
    CustomerIsNotChoosed: 'Der Kunde wird nicht ausgewählt',
    CustomerIsNotChoosedD: 'Wählen Sie den Kunden aus, um seine aktuelle Adresse anzuzeigen',
    SearchAddress: 'Adresse suchen',
    NoCustomerfound: 'Kein Kunde gefunden',
    NoCustomerfoundD: 'Sie können den Kunden erstellen, wenn es sich um einen neuen handelt',
    NewCustomer: 'Neuer Kunde',
    Existing: 'Vorhanden',
    EmailOtional: 'E-Mail (optional)',
    phonenumberisnotcorrect: 'Telefonnummer ist nicht korrekt',
    Emailisnotcorrect: 'E-Mail ist nicht korrekt',
    Registercustomer: 'Kunde registrieren',
    incoming: 'Eingehender Anruf',
    outgoing: 'ausgehender Anruf',
    recording: 'Anruf aufzeichnen',
    driveroperatorCallStatus: 'Der Fahrer rief den Operator an',
    customeroperatorCallStatus: 'Der Kunde rief den Operator an',
    newCustomeroperatorCallStatus: 'Neuer Kunde rief Betreiber an',
    operatordriverCallStatus: 'Der Betreiber rief den Fahrer an',
    operatorcustomerCallStatus: 'Der Betreiber rief den Kunden an',
    operatornewCustomerCallStatus: 'Betreiber rief neuen Kunden an',
    dispatcher_Voip: 'Operator',
    driver_Voip: 'Fahrer',
    customer_Voip: 'Kunde',
    activeorders: 'xxx aktive Bestellungen',
    Noactiveorder: 'Keine aktive Bestellung ',
    CreateOrder: 'Auftrag erstellen',
    call: 'Anruf',
    spanish: 'Spanisch',
    es: 'Spanisch',
    networkError: 'Keine Internetverbindung',
    germany: 'Deutschland',
    de: 'Deutsch',
    createdAt: 'Erstellt am',
    dueDate: 'Fälligkeitsdatum',
    Noresultfound: 'Kein Ergebnis gefunden',
    loadMore: 'Mehr laden',
    Searchresult: 'Suchergebnis',
    AssignedAt: 'Zuweisen bis xxx',
    StartedAt: 'Beginnen Sie bis xxx',
    ArrivedAt: 'Kommen Sie bis xxx',
    PickedUpAt: 'Abholung um xxx',
    DoneAt: 'Ende bei xxx',
    mindelay: 'xxxm Verzögerung',
    minlate: 'xxxm zu spät',
    PinTop: 'Oben feststecken',
    UnPin: 'Pin lösen',
    Itemsonmap: 'Elemente auf der Karte',
    min: 'xxx Min',
    Confirming: 'Bestätigen',
    delay: 'Verzögerung',
    late: 'Spät',
    OrderDetails: 'Bestelldetails',
    Profile: 'Profil',
    Waitingforavailabledrivers: 'Warten auf die Verfügbarkeit von Treibern',
    Queue: 'Warteschlange',
    OfferingToDrivers: 'Angebot für xxx-Fahrer',
    WaitforAccept: 'Warten Sie auf „Akzeptieren“.',
    Thereisnoorder: 'Es gibt keine Ordnung',
    mapitems: 'Kartenelemente',
    Offerings: 'Angebote',
    Reject: 'Ablehnen',
    dropoffCustomerDescription: 'Hinweis zur Abgabe',
    customerPhoto: 'Kundenfoto',
    driverPhoto: 'Fahrerfoto',
    NocustomerPhoto: 'Kein Kundenfoto',
    NodriverPhoto: 'Kein Fahrerfoto',
    initial: 'anfänglich',
    notifying: 'benachrichtigen',
    received: 'erhalten',
    assigned: 'zugewiesen',
    rejected: 'abgelehnt',
    canceled: 'abgesagt',
    standby: 'stehen zu',
    terminated: 'beendet',
    urgentTitle: 'Auf dringenden Versand umstellen?',
    urgentDesc: 'Wenn Sie „Dringend“ aktivieren, erhält die Bestellung die höchste Priorität für den Versand',
    urgentConfirm: 'Ja, „Dringend“ aktivieren',
    urgentClose: 'Nein, Abbrechen',
    Urgent: 'Dringend',
    photos: 'Fotos',
    Portuguese: 'Portugiesisch',
    Dispatchat: 'Versand um xxx',
    AutoDispatch: 'Automatischer Versand',
    Dispatchtime: 'Versandzeit',
    Later: 'Später',
    DispatchingNow: 'Jetzt versenden',
    NoResultfromLocalDatabase: 'Kein Ergebnis aus der lokalen Datenbank',
    NoResultfromLocalDatabaseD: 'Bitte überprüfen Sie es noch einmal oder versuchen Sie es mit einem anderen Schlüsselwort',
    NoResultfromMapService: 'Kein Ergebnis vom Kartendienst',
    now: 'Jetzt',
    ascending: 'Aufsteigend',
    descending: 'Absteigend',
    Last3Month: 'Letzte 3 Monate',
    Pickupnote: 'Abholschein',
    pop: 'Abholnachweis',
    Required: 'Erforderlich',
    SearchinMapService: 'Suche im Kartendienst',
    Creditcardnotadded: 'Kreditkarte nicht hinzugefügt',
    OptimizeDropoffs: 'Optimieren Sie Abgaben',
    Greek: 'griechisch',
    el: 'griechisch',
    ReferenceID: 'Referenz-ID',
    EnterId: 'Geben Sie die ID ein',
    German: 'Deutsch',
    AustrianGerman: 'Österreichisches Deutsch',
    EDAS_PickupFailed: 'Abholung fehlgeschlagen',
    EDAS_Lost: 'Verloren',
    EDAS_Returned: 'Zurückgegeben',
    EDAS_Draft: 'Entwurf',
    EDAS_Confirmed: 'Bestätigt',
    EDAS_PickupRouted: 'AbholungRouted',
    EDAS_ReadyForPickup: 'Bereit zur Abholung',
    EDAS_AtWarehouse: 'BeiWarehouse',
    EDAS_DeliveryRouted: 'LieferungRouted',
    EDAS_ReadyForDelivery: 'Bereit zur Lieferung',
    EDAS_OutForDelivery: 'OutForDelivery',
    EDAS_Delivered: 'Geliefert',
    EDAS_NotDelivered: 'Nicht geliefert',
    EDAS_ForReturn: 'Für die Rückkehr',
    Options: 'Optionen',
    VehicleOptions: 'Fahrzeugoptionen',
    EditCustomer: 'Kunde bearbeiten',
    NoDriverfound: 'Kein Fahrer gefunden',
    NoDriverfoundDesc: 'Überprüfen Sie Ihre Angaben und probieren Sie etwas anderes aus',
    ClearField: 'Feld löschen',
    Map: 'Karte',
    Local: 'Lokal',
    CompleteRequiredFeileds: 'Füllen Sie die erforderlichen Felder aus',
    Senderinfo: 'Absenderinformationen',
    Receiverinfo: 'Informationen zum Empfänger',
    'SchedulePickup(Optional)': 'Abholung vereinbaren (optional)',
    'ScheduleDelivery(Optional)': 'Lieferung planen (optional)',
    AddDropoff: 'Abgabe hinzufügen',
    Promotion: 'Förderung',
    tax: 'Steuer',
    Shipmentlabeldownloaded: 'Versandetikett heruntergeladen',
    statusDraft: 'Entwurf',
    statusConfirmed: 'Bestätigt',
    statusPickupRouted: 'AbholungRouted',
    statusReadyForPickup: 'Bereit zur Abholung',
    statusAtWarehouse: 'BeiWarehouse',
    statusDeliveryRouted: 'LieferungRouted',
    statusReadyForDelivery: 'Bereit zur Lieferung',
    statusOutForDelivery: 'OutForDelivery',
    statusDelivered: 'Geliefert',
    statusNotDelivered: 'Nicht geliefert',
    statusForReturn: 'Für die Rückkehr',
    statusReturned: 'Zurückgegeben',
    statusPickupFailed: 'Abholung fehlgeschlagen',
    statusLost: 'Verloren',
    event_Draft: 'Entwurf',
    event_Confirmed: 'Bestätigt',
    event_PickupRouted: 'AbholungRouted',
    event_ReadyForPickup: 'Bereit zur Abholung',
    event_AtWarehouse: 'BeiWarehouse',
    event_DeliveryRouted: 'LieferungRouted',
    event_ReadyForDelivery: 'Bereit zur Lieferung',
    event_OutForDelivery: 'OutForDelivery',
    event_Delivered: 'Geliefert',
    event_NotDelivered: 'Nicht geliefert',
    event_ForReturn: 'Für die Rückkehr',
    event_Returned: 'Zurückgegeben',
    event_PickupFailed: 'Abholung fehlgeschlagen',
    event_Lost: 'Verloren',
    event_IncomingCall: 'Eingehender Anruf',
    event_OutgoingCall: 'Ausgehender Anruf',
    event_DispatchOrder: 'Versandauftrag',
    tryagain: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut',
    'Selected date and time': 'Ausgewähltes Datum und Uhrzeit',
    'Reorder stops': 'Nachbestellung stoppt',
    'Bulk Edit Status Summary': 'Zusammenfassung des Massenbearbeitungsstatus',
    Successful: 'Erfolgreich',
    Failed: 'Fehlgeschlagen',
    'Order ID': 'Bestell-ID',
    'Pickup Routed': 'Abholung weitergeleitet',
    'Delivery Routed': 'Lieferung weitergeleitet',
    'Ref. xxx': 'Ref. xxx',
    Zone: 'Zone',
    Clear: 'Klar',
    'No result found': 'Kein Ergebnis gefunden',
    'Type your keyword': 'Geben Sie Ihr Schlüsselwort ein',
    'Type in the input to start search': 'Geben Sie die Eingabe ein, um die Suche zu starten',
    'We are sorry ...': 'Es tut uns leid...',
    'The page you are trying to access has restricted access.': 'Der Zugriff auf die Seite, auf die Sie zugreifen möchten, ist eingeschränkt.',
    'Please refer to your system administrator.': 'Bitte wenden Sie sich an Ihren Systemadministrator.',
    'Proof of delivery': 'Zustellnachweis',
    'Driver Photo': 'Fahrerfoto',
    'Order Info': 'Bestellinformationen',
    'P_HUB_D Orders': 'P_HUB_D Bestellungen',
    Routes: 'Routen',
    'Default pickup': 'Standardabholung',
    More: 'Mehr',
    'Route name': 'Routenname',
    Driver: 'Treiber',
    'Pickup Orders': 'Abholaufträge',
    'Delivery Orders': 'Lieferaufträge',
    'Ready For Pickup': 'Bereit zur Abholung',
    PricingAndEarning: 'Preisgestaltung und Verdienst',
    Pricing: 'Preise',
    save: 'Speichern',
    Learn: 'Lernen',
    Scheduleoverlap: 'Die geplante Abholzeit muss vor der geplanten Lieferzeit liegen und darf sich nicht überschneiden',
    PleaseSelectCustomer: 'Bitte Kunde auswählen',
    NoRegisteredCustomer: 'Kein registrierter Kunde',
    CreateAtLeastOneCustomerToCreateOrder: 'Erstellen Sie mindestens einen Kunden, um eine Bestellung zu erstellen',
    Pinned: 'Angepinnt',
    Delayed: 'Verzögert',
    Canceled: 'Abgesagt',
    InProgress: 'Im Gange',
    DispatchLater: 'VersandSpäter',
    Table: 'Tisch',
    'Clear All': 'Alles löschen',
    'Config Table': 'Konfigurationstabelle',
    'Active Columns': 'Aktive Spalten',
    'Due time': 'Fällige Zeit',
    'Search route name': 'Routennamen suchen',
    'Add Route': 'Route hinzufügen',
    'Route info': 'Routeninfo',
    'Start Location': 'Startort',
    'End Location ( Optional )': 'Endstandort (optional)',
    'Load Deliveries:': 'Lieferungen laden:',
    No: 'NEIN',
    Optional: 'Optional',
    Force: 'Gewalt',
    'Code, Name, Family, Phone number': 'Code, Name, Familie, Telefonnummer',
    'Edit Route Status & Driver': 'Routenstatus und Fahrer bearbeiten',
    'No, Cancel': 'Nein, Abbrechen',
    'Yes, Optimize': 'Ja, optimieren',
    'Optimize Stops?': 'Stopps optimieren?',
    'The sequence of stops changes automatically. you can change it manually later': 'Die Reihenfolge der Stopps ändert sich automatisch. Sie können es später manuell ändern',
    'Error in loading data': 'Fehler beim Laden der Daten',
    'There was a problem loading data. please try again or contact support': 'Beim Laden der Daten ist ein Problem aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support',
    'Try again': 'Versuchen Sie es erneut',
    'Duration:': 'Dauer:',
    'Edit Route info': 'Routeninformationen bearbeiten',
    'Edit Status & Driver': 'Status und Treiber bearbeiten',
    'Reorder Stops': 'Stopps neu anordnen',
    Optimize: 'Optimieren',
    'Search stops': 'Die Suche stoppt',
    'Delivery:': 'Lieferung:',
    'Pickup:': 'Abholen:',
    'No Stop was found': 'Es wurde kein Stopp gefunden',
    'Please check it again or try another keyword': 'Bitte überprüfen Sie es noch einmal oder versuchen Sie es mit einem anderen Schlüsselwort',
    'Add your orders': 'Fügen Sie Ihre Bestellungen hinzu',
    'You can add orders from orders pages': 'Sie können Bestellungen über Bestellseiten hinzufügen',
    'Go to Orders': 'Gehen Sie zu Bestellungen',
    'On Demand': 'Auf Anfrage',
    P_Hub_D: 'P_Hub_D',
    Notifications: 'Benachrichtigungen',
    'Admin Center': 'Admin Center',
    'Sort by': 'Sortieren nach',
    'Sort type': 'Sortiertyp',
    OrderType: 'Auftragstyp',
    Stage: 'Bühne',
    Status: 'Status',
    Route: 'Route',
    CreatedAt: 'Erstellt am',
    StatusUpdatedAt: 'StatusUpdatedAt',
    Note: 'Notiz',
    'Delivery Last Attempt Reason': 'Grund für den letzten Zustellungsversuch',
    'Delivery Attempts Count': 'Anzahl der Zustellversuche',
    'Pickup Failed Reason': 'Grund für fehlgeschlagene Abholung',
    ReferenceId: 'Referenz-ID',
    PickupAddress: 'Abholadresse',
    DeliveryAddress: 'Lieferadresse',
    'Driver Name': 'Fahrername',
    'Driver Phone': 'Fahrertelefon',
    'Customer Name': 'Kundenname',
    'Customer Phone': 'Kundentelefon',
    EstimatedDistanceInMeters: 'Geschätzte Entfernung in Metern',
    EstimatedDuration: 'Geschätzte Dauer',
    'Payment Method': 'Zahlungsmethode',
    PickupAddressDetail: 'PickupAddressDetail',
    PickupCompleteAfter: 'AbholungKomplettNachher',
    PickupcompleteBefore: 'Abholung abgeschlossenVorher',
    PickupFullName: 'PickupFullName',
    PickupPhone: 'PickupPhone',
    PickupEmail: 'AbholungEmail',
    PickupPodNote: 'PickupPodNote',
    PickupPodPhoto: 'PickupPodPhoto',
    PickupPodSignature: 'PickupPodSignatur',
    PickupZone: 'PickupZone',
    DeliveryAddressDetail: 'LieferadresseDetail',
    DeliveryCompleteAfter: 'LieferungKomplettNachher',
    DeliverycompleteBefore: 'LieferungkomplettVorher',
    DeliveryFullName: 'DeliveryFullName',
    DeliveryPhone: 'Liefertelefon',
    DeliveryEmail: 'LieferungE-Mail',
    DeliveryPodNote: 'DeliveryPodNote',
    DeliveryPodPhoto: 'DeliveryPodPhoto',
    DeliveryPodSignature: 'DeliveryPodSignature',
    DeliveryZone: 'Lieferzone',
    'Driver Vehicle': 'Fahrerfahrzeug',
    'Driver Username': 'Benutzername des Fahrers',
    CustomerType: 'Kundentyp',
    'Customer Email': 'Kunden-E-Mail',
    PaymentProvider: 'Zahlungsanbieter',
    Source: 'Quelle',
    'Shipment Label': 'Versandetikett',
    'Track Order': 'Bestellung verfolgen',
    'Create your first order': 'Erstellen Sie Ihre erste Bestellung',
    'Your orders will be shown here in table with full details and actions': 'Ihre Bestellungen werden hier in einer Tabelle mit allen Details und Aktionen angezeigt',
    'Please check your filters or keyword': 'Bitte überprüfen Sie Ihre Filter oder Ihr Schlüsselwort',
    from: 'aus',
    rows: 'Reihen',
    Prev: 'Vorher',
    Next: 'Nächste',
    Stages: 'Stufen',
    RouteName: 'Routenname',
    Services: 'Dienstleistungen',
    PaymentSides: 'Zahlungsseiten',
    pickupzones: 'Abholzonen',
    deliveryzones: 'Lieferzonen',
    Zones: 'Zonen',
    CodAmount: 'CodAmount',
    'Payment Methods': 'Zahlungsmethoden',
    'Delivery Attempt Number': 'Nummer des Zustellversuchs',
    paymentMethods: 'Zahlungsmethoden',
    'Edit Status': 'Status bearbeiten',
    'Select Status': 'Wählen Sie Status aus',
    'Select Reason': 'Wählen Sie Grund aus',
    'Select Route': 'Wählen Sie Route',
    'Don’t change routes': 'Ändern Sie keine Routen',
    'Edit routes': 'Routen bearbeiten',
    'Remove routes': 'Routen entfernen',
    'You must assign driver to select this route': 'Sie müssen den Fahrer zuweisen, um diese Route auszuwählen',
    'You must choose an unassigned route or unassign selected route': 'Sie müssen eine nicht zugewiesene Route auswählen oder die Zuweisung einer ausgewählten Route aufheben',
    'Create P_HUB_D Only order': 'P_HUB_D-Auftrag erstellen',
    'Add routes': 'Routen hinzufügen',
    'Your routes will be shown here in': 'Ihre Routen werden hier angezeigt',
    'Add orders': 'Bestellungen hinzufügen',
    'Bulk select in orders list and add orders with edit status button': 'Massenauswahl in der Bestellliste und Hinzufügen von Bestellungen mit der Schaltfläche „Status bearbeiten“.',
    'Create Ondemand order': 'Erstellen Sie eine On-Demand-Bestellung',
    'Your orders will be shown here in list': 'Ihre Bestellungen werden hier in der Liste angezeigt',
    'Create Pickup Only order': 'Erstellen Sie eine Bestellung nur zur Selbstabholung',
    'Create Delivery Only order': 'Erstellen Sie eine Bestellung nur mit Lieferung',
    'No offline driver': 'Keine Offline Fahrer',
    'Offline drivers will be shown here': 'Offline Fahrer werden hier angezeigt',
    'No online driver': 'Keine Online Fahrer',
    'Online drivers will be shown here': 'Online Fahrer werden hier angezeigt',
    'Driver login info': 'Anmeldeinformationen des Fahrers',
    'Driver must be online in the app to see it here  and be able to assign orders': 'Um es hier zu sehen und Aufträge zuordnen zu können, muss der Fahrer in der App online sein',
    'Scan to Download Driver app': 'Scannen, um die Fahrer-App herunterladen',
    OR: 'ODER',
    'Open the link in your phone': 'Öffnen Sie den Link in Ihrem Telefon',
    'Copy link to clipboard': 'Link in die Zwischenablage kopieren',
    'Copied!': 'Kopiert!',
    'Add drivers': 'Fahrer hinzufügen',
    Pleasetryanotherkeyword: 'Bitte versuche eine anderes Passwort',
    Itisnotpossibletorepeattherequest: 'Eine Wiederholung des Auftrages ist nicht möglich',
    SearchinLocalDatabase: 'Suche in lokaler Datenbank'

}; 